import { Grid, Table, TableHead, TableRow, TableCell, TableContainer, Dialog, Button, TableBody, Box, Typography } from "@material-ui/core";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AceptarRechazarTramite, getMaterialesTramite } from "../../../actions/compras/AuditoriaFactura";
import { useState } from "react";
import { TextValidator, ValidatorForm } from "react-material-ui-form-validator";
import { ESTADOS_AUDITORIAFACTURACION_COMPRAS } from "../../../utils/constants";


export const ModalAceptarFacturacion = (props) => {
    const { comprobante, esCarga } = props;
    const dispatch = useDispatch();
    const { materialesTramite } = useSelector((state) => state.auditoriaFacturacion);
    let materiales = [];
    const [observaciones, setObservaciones] = useState("");
    let contador = 0;

    useEffect(() => {
        dispatch(getMaterialesTramite(comprobante.idTramitesCompras));
    }, [dispatch, comprobante.idTramitesCompras]);

    console.log("materiales", materialesTramite)
    console.log("comprobante", comprobante);

    if (materialesTramite.length > 0 && comprobante.idSolicitud !== null) {
        materiales = materialesTramite[0].detalleTramites

    } else if (materialesTramite.length > 0) {
        materiales = materialesTramite[0].detalleFacturacionSinCotizacion

    } else {
        materiales = [];
    }

    const handleSave = () => {
        dispatch(AceptarRechazarTramite(comprobante.idTramitesCompras, observaciones,props.estado));
        props.closeModalHandler(); 
    }

    return (
        <Dialog
            fullWidth
            maxWidth={'lg'}
            open={props.open}
        >
            <Grid>
                <Typography variant="h5" align="center" style={{ margin: '0.5rem' }}>{comprobante.tipoComprobante} - {comprobante.nroComprobante}</Typography>
                <Grid container justify="center" spacing={1}>
                    <TableContainer style={{ overflowX: "auto", marginTop: '1rem', padding: '2rem' }}>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell style={{ textAlign: 'center' }}>Material/Producto</TableCell>
                                    <TableCell style={{ textAlign: 'center' }}>Cantidad</TableCell>
                                    <TableCell style={{ textAlign: 'center' }}>Precio Unitario</TableCell>
                                    <TableCell style={{ textAlign: 'center' }}>Subtotal</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {
                                    materiales.length > 0 &&
                                    materiales.map((item) => {
                                        contador = (item.cantidad * item.precioUnitario) + contador
                                        return (
                                            <TableRow>
                                                <TableCell style={{ textAlign: 'center' }}>{comprobante.idSolicitud ? item.materiales.descripcion : item.producto}</TableCell>
                                                <TableCell style={{ textAlign: 'center' }}>{item.cantidad}</TableCell>
                                                <TableCell style={{ textAlign: 'center' }}>{`$${item.precioUnitario}`}</TableCell>
                                                <TableCell style={{ textAlign: 'center' }}>{`$${item.precioUnitario * item.cantidad}`}</TableCell>
                                            </TableRow>
                                        )
                                    })
                                }
                                < TableRow style={{ backgroundColor: "#F7F2F9" }}>
                                    <TableCell></TableCell>
                                    <TableCell></TableCell>
                                    <TableCell style={{ textAlign: 'center' }}>Total</TableCell>
                                    <TableCell style={{ textAlign: 'center' }}>${contador}</TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Grid>
            </Grid>
            <ValidatorForm>
                <Box p={3}>
                    <Grid style={{ padding: '2rem' }}>
                        <TextValidator
                            value={esCarga || ESTADOS_AUDITORIAFACTURACION_COMPRAS.PENDIENTE_PAGO ? observaciones : materialesTramite[0].motivoRechazo}
                            margin="normal"
                            label="Motivo de Rechazo"
                            name="observaciones"
                            autoComplete="off"
                            disabled={esCarga ? false : true}
                            fullWidth
                            multiline={true}
                            rows={3}
                            rowsMax={8}
                            onChange={(event) => { setObservaciones(event.target.value) }}
                        />
                    </Grid>
                </Box>
                <Grid container style={{ padding: '15px' }}>
                    <Grid item xs={12}>
                        <Grid
                            container
                            direction="row"
                            justify="center"
                            alignItems="center"
                        >
                            <Button
                                variant="contained"
                                color="inherit"
                                onClick={props.closeModalHandler}>
                                Cerrar
                            </Button>
                            {esCarga && (
                                <>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        style={{ textAlign: 'center', marginLeft: '1rem' }}
                                        disabled={observaciones === "" ? true : false}
                                        onClick={handleSave}
                                    >
                                        Rechazar
                                    </Button>

                                    <Button
                                        variant="contained"
                                        color="primary"
                                        style={{ textAlign: 'center', marginLeft: '1rem' }}
                                        type='submit'
                                        disabled={observaciones !== "" ? true : false}
                                        onClick={handleSave}
                                    >
                                        Aceptar
                                    </Button>
                                </>
                            )}
                        </Grid>
                    </Grid>
                </Grid>
            </ValidatorForm>
        </Dialog>
    )
};